import { Box, Portal } from '@chakra-ui/react';
import type { ComponentProps } from 'react';

import { ADVISOR_PANEL_BOX_SHADOW, ADVISOR_PANEL_NEUTRAL_100 } from './advisor-panel-tokens';
import { ADVISOR_SIDE_PANEL_WIDTH, ADVISOR_SIDE_PANEL_Z_INDEX } from './advisor-side-panel';

export type AdvisorSidePanelFrameProps = ComponentProps<typeof Box>;

/**
 * Fixed right-hand shell for the in-app assistant (one agent; lanes differ by `use_case`).
 * Shared layout (width, z-index, shadow, flex column) for org and partner surfaces.
 * Portaled to `document.body` so ancestor transforms (e.g. onboarding tour) do not offset
 * `position: fixed` and leave a gap on the right edge of the viewport.
 */
export function AdvisorSidePanelFrame({ children, ...rest }: AdvisorSidePanelFrameProps) {
  return (
    <Portal>
      <Box
        position="fixed"
        insetBlock={0}
        insetInlineEnd={0}
        w={ADVISOR_SIDE_PANEL_WIDTH}
        maxW="100vw"
        zIndex={ADVISOR_SIDE_PANEL_Z_INDEX}
        bg="white"
        display="flex"
        flexDirection="column"
        borderLeftWidth="1px"
        borderLeftColor={ADVISOR_PANEL_NEUTRAL_100}
        boxShadow={ADVISOR_PANEL_BOX_SHADOW}
        {...rest}
      >
        {children}
      </Box>
    </Portal>
  );
}
